/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyMagicLink} from '../api'

export const useMutationVerifyMagicLink = createReactQueryMutationHook('verifyMagicLink', verifyMagicLink)
